(() => {
  if (window.drpSizeGuideReady) return;
  window.drpSizeGuideReady = true;
  let opener;
  const finish = dialog => {
    dialog.classList.remove('is-open');
    document.body.classList.remove('drp-guide-open');
    opener?.focus();
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-drp-guide-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!dialog) return;
      opener = trigger;
      dialog.showModal();
      document.body.classList.add('drp-guide-open');
      requestAnimationFrame(() => requestAnimationFrame(() => dialog.classList.add('is-open')));
      dialog.querySelector('[data-drp-guide-close]').focus();
      dialog.addEventListener('close', () => finish(dialog), { once: true });
      return;
    }
    const dialog = event.target.closest('dialog.drp-size-guide');
    if (!dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.target.closest('[data-drp-guide-close]') || (event.target === dialog && (event.clientX > bounds.right || event.clientX < bounds.left))) dialog.close();
  });
})();
